import Button from 'ui/buttons/Button'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'
import React from 'react'

export default function SmartviewButton ({
  children,
  smartview,
  replace = false
}) {
  return (
    <MountSmartviewOnClick smartview={smartview} replace={replace}>
      <Button>
        {children}
      </Button>
    </MountSmartviewOnClick>
  )
}
